import type { ValueOf } from 'type-fest';

import type { BannerPlacement } from '../effect/schema/openapi/backend';

export const BannerPlacementType = {
  HOMEPAGE: 'homepage',
  CATEGORY_LISTING_1: 'category_listing_1',
  CATEGORY_LISTING_2: 'category_listing_2',
  CATEGORY_FOOTER: 'category_footer',
  PRODUCT_UNDER_GALLERY: 'product_under_gallery',
  PRODUCT_MAIN_INFO: 'product_main_info',
  CUSTOMER_GUIDE: 'customer_guide',
  CATEGORY_DESCRIPTION: 'category_description',
} as const satisfies Record<string, BannerPlacement>;

export type BannerPlacementTypeT = ValueOf<typeof BannerPlacementType>;
